import { jsx as _jsx } from "react/jsx-runtime";
import RecommendationsSection from './RecommendationsSection';
import UsageTracker from '../../utils/UsageTracker';
import { useHistory } from 'react-router-dom';
import { FormattedMessage, FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import styled from 'styled-components';
import { device } from '../../constants/StyledComponentConstants'; //@ts-expect-error Could not find declaration file for module

import useMediaQuery from '../../hooks/useMediaQuery';
import { useSavedLearningInterest } from '../../features/wizard';
import useWizard from '../../hooks/useWizard';
import { OverviewSource } from '../../features/tracks';
import { RouterLink } from '../AcademyLinks';
const HeaderActionLink = styled(RouterLink).withConfig({
  displayName: "RecommendationsBasedOnInterest__HeaderActionLink",
  componentId: "sc-1jwrxjb-0"
})(["font-size:14px;"]);

const TitleAction = ({
  resultsCount,
  resultsUrl
}) => {
  const handleViewResults = () => {
    UsageTracker.track('interaction', {
      action: 'interest-recommendations-view-results-clicked'
    });
  };

  return resultsCount > 3 ? /*#__PURE__*/_jsx(HeaderActionLink, {
    onClick: handleViewResults,
    to: resultsUrl,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.wizard.modal.stepfinal.resultslink",
      options: {
        resultsCount
      }
    })
  }) : null;
};

const SubTitle = ({
  selectedCategory,
  selectedCategoryGroup,
  selectedTool,
  selectedToolsGroup
}) => {
  const history = useHistory();

  const handleSetLearningInterest = () => {
    UsageTracker.track('interaction', {
      action: 'interest-recommendations-set-learning-interest-clicked'
    });
    history.push('/wizard');
  };

  let message = null;
  if (selectedCategory) message = `learningCenter.topFilters.cat.${selectedCategory}`;else if (selectedCategoryGroup) message = `learningCenter.filtersGroups.${selectedCategoryGroup}`;else if (selectedTool) message = `learningCenter.topFilters.tools.${selectedTool}`;else if (selectedToolsGroup) message = `learningCenter.filtersGroups.${selectedToolsGroup}`;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: message ? `learningCenter.tracks.subheaders.learningInterest` : `learningCenter.tracks.subheaders.learningInterestGeneric`,
    options: {
      learningInterest: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "learning-interest-label",
        message: message || ''
      }),
      setInterestLink: /*#__PURE__*/_jsx(RouterLink, {
        "data-test-id": "preference-change-button",
        onClick: handleSetLearningInterest,
        to: "/wizard",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `learningCenter.fieldLink.edit`
        })
      })
    }
  });
};

const RecommendationsBasedOnInterest = () => {
  const savedLearningInterest = useSavedLearningInterest();
  const {
    resultCount,
    selectedCategory,
    selectedCategoryGroup,
    selectedTool,
    selectedToolsGroup
  } = savedLearningInterest;
  const {
    resultsUrl,
    topResults
  } = useWizard(savedLearningInterest);
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  return /*#__PURE__*/_jsx(RecommendationsSection, {
    recommendations: topResults.map(result => {
      return {
        recommendationId: result.id,
        recommendationStrategy: 'LEARNING_INTEREST',
        recommendationType: result.contentType,
        recommendationMetadata: {
          entityId: result.id,
          entityType: result.contentType,
          progressType: result.status
        }
      };
    }),
    source: OverviewSource.RecommendationsInterest,
    subTitle: /*#__PURE__*/_jsx(SubTitle, {
      selectedCategory: selectedCategory,
      selectedCategoryGroup: selectedCategoryGroup,
      selectedTool: selectedTool,
      selectedToolsGroup: selectedToolsGroup
    }),
    testId: "recommendations-based-on-interest",
    titleAction: !isMobile ? /*#__PURE__*/_jsx(TitleAction, {
      resultsCount: resultCount,
      resultsUrl: resultsUrl
    }) : undefined
  });
};

export default RecommendationsBasedOnInterest;